<template>
  <div id="login">

    <!-- Spinner -->
    <transition name="fade">
      <RingLoader v-if="performingRequest" :color="this.spinnerColor" :size="this.spinnerSize"></RingLoader>
    </transition>

    <div class="login-form">

      <!-- Error Message -->
      <transition name="fade">
        <div
          v-if="errorMsg !== ''"
          class="alert alert-warning"
          role="alert"
        >
        {{ errorMsg }}
        </div><!-- error-msg -->
      </transition>

      <div
        :class="{ 'signup-form': !showLoginForm && !showForgotPassword }"
      >

        <!-- Login Form -->
        <form v-if="showLoginForm" @submit.prevent>
          <div class="form-group">
            <label for="email1">Email</label>
            <input v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" class="form-control" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label for="password1">Password</label>
            <input v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" class="form-control" />
          </div><!-- /.form-group -->
          <button @click="login" class="btn btn-primary">Log In</button>
          <div class="extras">
            <button class="btn btn-sm btn-default" @click="togglePasswordReset">Forgot Password</button>
            <button class="btn btn-sm btn-default" @click="toggleForm">Create an Account</button>
          </div><!-- /.extras -->
        </form>

        <!-- Signup Form -->
        <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
          <h2>Create an Account</h2>
          <div class="form-group">
            <label for="email2">Email</label>
            <input v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email2" class="form-control" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label for="password2">Password</label>
            <input v-model.trim="signupForm.password" type="password" placeholder="min 6 characters" id="password2" class="form-control" />
          </div><!-- /.form-group -->
          <button @click="signup" class="btn btn-primary">Sign Up</button>
          <div class="extras">
            <button class="btn btn-sm btn-default" @click="toggleForm">Back to Log In</button>
          </div><!-- /.extras -->
        </form>

        <!-- Forgot Password -->
        <form v-if="showForgotPassword" @submit.prevent class="password-reset">
          <div v-if="!passwordResetSuccess">
            <h2>Reset Password</h2>
            <p>We will send you an email to reset your password</p>
            <div class="form-group">
              <label for="email3">Email</label>
              <input v-model.trim="passwordForm.email" type="text" placeholder="you@email.com" id="email3" class="form-control" />
            </div><!-- /.form-control -->
            <button @click="resetPassword" class="btn btn-primary">Submit</button>
            <div class="extras">
              <button @click="togglePasswordReset" class="btn btn-sm btn-default">Back to Log In</button>
            </div><!-- /.extras -->
          </div><!-- /v-if=!passwordResetSuccess -->
          <div v-else>
            <h2>Email Sent</h2>
            <p>check your email for a link to reset your password</p>
            <button @click="togglePasswordReset" class="btn btn-primary">Back to login</button>
          </div><!-- /v-else -->
        </form>

      </div><!-- /.signup-form -->
    </div><!-- /.container -->

  </div><!-- /#login -->
</template>

<script>
  import RingLoader from 'vue-spinner/src/RingLoader.vue'
  const fb = require('../../firebaseConfig.js')

  export default {
    components: { RingLoader },
    data() {
      return {
        loginForm: {
          email: '',
          password: ''
        },
        signupForm: {
          email: '',
          password: ''
        },
        passwordForm: {
          email: ''
        },
        showLoginForm: true,
        showForgotPassword: false,
        passwordResetSuccess: false,
        performingRequest: false,
        spinnerColor: '#61539b',
        spinnerSize: '50px',
        errorMsg: ''
      }
    },
    methods: {
      toggleForm() {
        this.errorMsg = ''
        this.showLoginForm = !this.showLoginForm
      },
      togglePasswordReset() {
        if (this.showForgotPassword) {
          this.showLoginForm = true
          this.showForgotPassword = false
          this.passwordResetSuccess = false
        } else {
          this.showLoginForm = false
          this.showForgotPassword = true
        }
      },
      login() {
        this.performingRequest = true
        fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
          this.$store.commit('setCurrentUser', user.user)
          this.$store.dispatch('fetchUserProfile')
          fb.dashboardsCollection.where("createdBy", "==", user.user.uid).limit(1).get().then(dashboards => {
            let dashboardData = dashboards.docs[0].data()
            dashboardData.id = dashboards.docs[0].id
            console.log(dashboardData)
            this.performingRequest = false
            this.$router.push('/admin/' + dashboardData.id)
          })
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      },
      signup() {
        this.performingRequest = true
        // Create User
        fb.auth.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password).then(user => {
          this.$store.commit('setCurrentUser', user.user)
          // Create User Document
          fb.usersCollection.doc(user.user.uid).set({
            createdOn: new Date(),
            email: this.signupForm.email
          }).then(() => {
            // Create a dashboard for this user
            fb.dashboardsCollection.add({
              createdBy: user.user.uid,
              design: {},
              modules: {}
            }).then(dashboard => {
              // Get user data, set in store, forward to admin page with router id being the dashboard just created
              this.$store.dispatch('fetchUserProfile')
              this.performingRequest = false
              this.$router.push('/admin/' + dashboard.id)
            })
          }).catch(err => {
            console.log(err)
            this.performingRequest = false
            this.errorMsg = err.message
          })
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      },
      resetPassword() {
        this.performingRequest = true
        fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
          this.performingRequest = false
          this.passwordResetSuccess = true
          this.passwordForm.email = ''
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/admin/Login.vue